/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8 19.5455C8.6586 21.0273 10.3784 22 12 22C13.6216 22 15.3414 21.0273 16 19.5455M20 14.5L18.9735 13.3762C18.3539 12.8185 18 12.0239 18 11.1902V8C18 4.68629 15.3137 2 12 2C10.7733 2 9.63251 2.36815 8.68221 3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3 2L6.53025 5.53025M22 21L19.3332 18.3332M6.53025 5.53025C6.18961 6.28347 5.99999 7.11959 5.99999 8V11.1902C5.99999 12.0239 5.64614 12.8185 5.02646 13.3762L3.91853 14.3733C2.59603 15.5636 3.01796 17.7338 4.69008 18.3419L4.90108 18.4186C9.4868 20.0861 14.5132 20.0861 19.0989 18.4186C19.177 18.3902 19.2554 18.3624 19.3332 18.3332M6.53025 5.53025L19.3332 18.3332"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M4.69008 18.3418L4.90108 18.4186C9.4868 20.0861 14.5132 20.0861 19.0989 18.4186C19.177 18.3902 19.2554 18.3624 19.3332 18.3332L6.53025 5.53024C6.18962 6.28346 5.99999 7.11958 5.99999 7.99999V11.1902C5.99999 12.0239 5.64614 12.8185 5.02646 13.3762L3.91853 14.3733C2.59603 15.5636 3.01796 17.7338 4.69008 18.3418Z"
				fill="currentColor"
			/>
			<path
				d="M7.99999 19.5455C8.65859 21.0273 10.3784 22 12 22C13.6216 22 15.3414 21.0273 16 19.5455M20 14.5L18.9735 13.3762C18.3538 12.8185 18 12.0239 18 11.1902V8C18 4.68629 15.3137 2 12 2C10.7733 2 9.6325 2.36815 8.6822 3M3 2L6.53025 5.53025M22 21L19.3332 18.3332M6.53025 5.53025C6.18961 6.28347 5.99999 7.11959 5.99999 8V11.1902C5.99999 12.0239 5.64614 12.8185 5.02646 13.3762L3.91853 14.3733C2.59603 15.5636 3.01796 17.7338 4.69008 18.3419L4.90108 18.4186C9.4868 20.0861 14.5132 20.0861 19.0989 18.4186C19.177 18.3902 19.2554 18.3624 19.3332 18.3332M6.53025 5.53025L19.3332 18.3332"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.53033 1.46967C3.23744 1.17678 2.76256 1.17678 2.46967 1.46967C2.17678 1.76256 2.17678 2.23744 2.46967 2.53033L5.64845 5.70911C5.39041 6.42438 5.24976 7.19577 5.24976 8V10.0692C5.24976 10.7747 4.98555 11.4546 4.50918 11.9749L3.10847 13.5049C1.88345 14.843 2.37893 16.9935 4.06597 17.6606C8.59238 19.4506 13.5731 19.651 18.2013 18.2619L21.4697 21.5303C21.7626 21.8232 22.2374 21.8232 22.5303 21.5303C22.8232 21.2374 22.8232 20.7626 22.5303 20.4697L3.53033 1.46967ZM11.9999 1.25C10.7615 1.25 9.5912 1.55071 8.56006 2.08376C8.19211 2.27397 8.04802 2.72646 8.23823 3.09441C8.42845 3.46237 8.88093 3.60646 9.24889 3.41624C10.0721 2.99068 11.0068 2.75 11.9999 2.75C15.3136 2.75 17.9999 5.43629 17.9999 8.75V10.8192C17.9999 11.7122 18.3343 12.5727 18.9373 13.2314L20.338 14.7614C20.6177 15.0669 21.0921 15.0878 21.3976 14.8081C21.7031 14.5284 21.7241 14.054 21.4444 13.7485L20.0436 12.2185C19.6939 11.8364 19.4999 11.3372 19.4999 10.8192V8.75C19.4999 4.60786 16.142 1.25 11.9999 1.25ZM11.9999 23.0002C10.1678 23.0002 8.62334 21.7684 8.14954 20.0879C10.6972 20.5299 13.3026 20.5299 15.8502 20.0879C15.3764 21.7684 13.832 23.0002 11.9999 23.0002Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M7.99999 19.5455C8.65859 21.0273 10.3784 22 12 22C13.6216 22 15.3414 21.0273 16 19.5455M20 14.5L18.9735 13.3762C18.3538 12.8185 18 12.0239 18 11.1902V8C18 4.68629 15.3137 2 12 2C10.7733 2 9.6325 2.36815 8.6822 3M3 2L6.53025 5.53025L19.3332 18.3332M22 21L19.3332 18.3332M19.3332 18.3332C19.2554 18.3624 19.177 18.3902 19.0989 18.4186C14.5132 20.0861 9.4868 20.0861 4.90108 18.4186L4.69008 18.3419C3.01796 17.7338 2.59603 15.5636 3.91853 14.3733L5.02646 13.3762C5.64614 12.8185 5.99999 12.0239 5.99999 11.1902V9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M7.99999 19.5455C8.65859 21.0273 10.3784 22 12 22C13.6216 22 15.3414 21.0273 16 19.5455M20 14.5L18.9735 13.3762C18.3538 12.8185 18 12.0239 18 11.1902V8C18 4.68629 15.3137 2 12 2C10.7733 2 9.6325 2.36815 8.6822 3M3 2L6.53025 5.53025M22 21L19.3332 18.3332M6.53025 5.53025C6.18961 6.28347 5.99999 7.11959 5.99999 8V11.1902C5.99999 12.0239 5.64614 12.8185 5.02646 13.3762L3.91853 14.3733C2.59603 15.5636 3.01796 17.7338 4.69008 18.3419L4.90108 18.4186C9.4868 20.0861 14.5132 20.0861 19.0989 18.4186C19.177 18.3902 19.2554 18.3624 19.3332 18.3332M6.53025 5.53025L19.3332 18.3332"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M20.8911 13.5049L19.4904 11.9749C19.014 11.4546 18.7498 10.7747 18.7498 10.0692V8C18.7498 4.27208 15.7277 1.25 11.9998 1.25C9.34949 1.25 7.05594 2.77742 5.95142 5L18.9676 18.0162C19.2917 17.9056 19.6138 17.7871 19.9336 17.6606C21.6206 16.9935 22.1161 14.843 20.8911 13.5049Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.53033 1.46967C3.23744 1.17678 2.76256 1.17678 2.46967 1.46967C2.17678 1.76256 2.17678 2.23744 2.46967 2.53033L5.64845 5.70911C5.39041 6.42438 5.24976 7.19577 5.24976 8V10.0692C5.24976 10.7747 4.98555 11.4546 4.50918 11.9749L3.10847 13.5049C1.88345 14.843 2.37893 16.9935 4.06597 17.6606C8.59238 19.4506 13.5731 19.651 18.2013 18.2619L21.4697 21.5303C21.7626 21.8232 22.2374 21.8232 22.5303 21.5303C22.8232 21.2374 22.8232 20.7626 22.5303 20.4697L3.53033 1.46967ZM11.9999 23.0002C10.1678 23.0002 8.62334 21.7684 8.14954 20.0879C10.6972 20.5299 13.3026 20.5299 15.8502 20.0879C15.3764 21.7684 13.832 23.0002 11.9999 23.0002Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
